export default class Carousel {
	constructor( $node ) 
	{
		this.$node  = $node
		this.$wrap  = $node.querySelector('.carousel-wrapper')

		var observe = this.$node.classList.contains('retain-focus')

		if( this.$node.classList.contains('has-navigation') )
		{
			this._initializeNavigation()
			observe = true
		}

		if( this.$node.classList.contains('has-bullets') )
		{	
			observe = true
		}

		if ( this.$node.classList.contains('draggable') ) 
		{
			this._initDrag()
		}

		window.addEventListener('resize', this._observeResize.bind( this ) )
		window.addEventListener('orientationchange', this._observeResize.bind( this ) )
		this.$node.addEventListener('recalculate', this._observeResize.bind( this ) )
		
		if( observe )
		{
			$node.querySelector('.carousel-wrapper').addEventListener('scroll', this._observeScroll.bind( this ) )
		}

		this._observeResize()
	}

	/**
	 * (Re)calulate the focused items
	 * 
	 * @return 	Carousel
	 */
	_calculateFocus() 
	{
		if( !this.$node.classList.contains('retain-focus') )
		{
			return;
		}

		var margin = 0.3

		// Detect focussed items
		Array.from( this.$node.querySelectorAll('.carousel-item') ).forEach(function( node ) {

			var bounds = node.getBoundingClientRect()

			var offset = bounds.left
			var width  = bounds.width

			var focused = false

			if ( offset < width ) 
			{
				if ( offset <= 0 ) 
				{
					focused = offset + (width * (1 - margin)) > 0
				} 
				else 
				{
					focused = offset - (width * (1 - margin)) < 0
				}
			}

			// only toggle on change due to mobile animations
			if ( node.classList.contains('focus') != focused ) 
			{
				if ( focused ) {
					node.classList.add('focus')
				} else {
					node.classList.remove('focus')
				}
			}

		})

		return this
	}

	/**
	 * Action to preform upon actual drag
	 */
	_dragAction( e ) 
	{
		e = e || window.event;
		e.preventDefault();

		this.$wrap.scrollLeft = this._pos.wrap + ( this._pos.client - e.clientX );
	}
	
	/**
	 * Observe drag end event
	 */ 
	_dragEnd( e ) 
	{
		e = e || window.event;
		e.preventDefault();

		document.onmouseup = null;
		document.onmousemove = null;
	}

	/**
	 * Observe drag start event
	 */
	_dragStart( e ) 
	{ 
		e = e || window.event;
		e.preventDefault();

		this._pos = { client: e.clientX, wrap: this.$wrap.scrollLeft }

		document.onmouseup = this._dragEnd.bind(this);
		document.onmousemove = this._dragAction.bind(this);
	}

	/**
	 * Initialize the bullet navigation
	 * 
	 * @access 	private
	 * @return 	Carousel
	 */
	_initializeBullets() 
	{
		var self  = this
		var $list = document.querySelector('.slide-nav.nav-bullet')

		if( $list )
		{	
			$list.parentNode.removeChild( $list )
		}

		var rect = this._getRect()

		// skip bullets when only one slide is detected
		if( rect.slideCount <= 1 )
		{
			return this
		} 

		$list = document.createElement('ul')
		$list.classList.add('slide-nav')
		$list.classList.add('nav-bullet')

		for( var i = 0; i < rect.slideCount; i++ )
		{
			// Scope in function to avoid reference issues
			(function( slide ){	
				var $bullet = document.createElement('li')
					$bullet.addEventListener('click', function(){ self.slideTo( slide ) })

				$list.append( $bullet )
			})( i )
		}

		this.$node.append( $list )
		this._relocateCTA() 

		return this
	}

	/**
	 * Initialize drag support
	 * 
	 * @access 	private
	 */
	_initDrag() 
	{
		Array.from( this.$wrap.childNodes ).forEach(item => {
			item.addEventListener('mousedown', this._dragStart.bind(this));
		})
	}

	/**
	 * Initialize the navigation
	 * 
	 * @access 	private
	 */
	_initializeNavigation() 
	{
		var $wrap = document.createElement('div')
			$wrap.classList.add('slide-nav')
			$wrap.classList.add('nav-arrow')
		
		var $prev = document.createElement('div')
			$prev.classList.add('slide-arrow')
			$prev.classList.add('slide-prev')
			$prev.addEventListener('click', this.slidePrev.bind( this ) )

		$wrap.append( $prev )

		var $next = document.createElement('div')
			$next.classList.add('slide-arrow')
			$next.classList.add('slide-next')
			$next.addEventListener('click', this.slideNext.bind( this ) )

		$wrap.append( $next )

		this.$node.append( $wrap )
		this._relocateCTA()

		return this
	}

	/** 
	 * Get bounding rect
	 * 
	 * @return 	json
	 */
	_getRect()
	{
	//	return { ...this._rect, ...{ left: this.$wrap.scrollLeft } }

		// Eslint failes on my beautifull line, so do this instead
		this._rect.left = this.$wrap.scrollLeft

		return this._rect
	}

	/**
	 * Return the number of the current slide
	 * 
	 * @return	int
	 */
	_getSlideNumber()
	{
		var rect  = this._getRect()
		var slide = 0 

		// When scrolled to the end force to last slide
		if( rect.left + rect.viewport >= rect.width - rect.slideWidth * 0.25 )
		{
			slide = rect.slideCount - 1
		}
		else if( rect.left )
		{
			// Multiply and devide by 10 to prevent rounding issues
			slide = Math.round( Math.floor( ( rect.left / rect.slideWidth ) * 10 ) / 10 )
		}

		return slide
	}

	/**
	 * Observe a resize event
	 */
	_observeResize()
	{
		// --------------------------------------------------------------------
		// Recalculate slide width
		var style = this.$wrap.currentStyle || window.getComputedStyle( this.$wrap )
		var slideWidth = 0

		// Reset scroll
		var pos = this.$wrap.scrollLeft
		this.$wrap.scrollLeft = 0

		var boxWidth  = Math.ceil( this.$wrap.getBoundingClientRect().width )
		var viewport  = boxWidth - parseInt( style.paddingLeft ) 

		// -- Slider consists of 1 fullwidth item
		for( var i = 0; i < this.$wrap.childNodes.length; i++ )
		{
			var item = this.$wrap.childNodes[ i ]

			if (typeof(item) == Element) {
				style = item.currentStyle || window.getComputedStyle( item )
				var width = item.offsetWidth + parseFloat( style.marginLeft ) + parseFloat( style.marginRight )
			}

			if( item.offsetLeft + width <= viewport )
			{
				slideWidth += width
			}
			else 
			{
				break;
			}
		}

		slideWidth = Math.max( slideWidth, boxWidth )

		// Calculate slide rect 
		this._rect = {
			left: 0,
			width: this.$wrap.scrollWidth,
			viewport: boxWidth,
			slideWidth: slideWidth || boxWidth,
			slideCount: 0
		}
		
		// round with 10 to prevent rounding issues
		this._rect.slideCount = Math.ceil( Math.floor( ( this._rect.width / this._rect.slideWidth ) * 10 ) / 10 ) 

		// Restore position
		this.$wrap.scrollLeft = pos 

		// -- Rebuild bullets

		if( this.$node.classList.contains('has-bullets') )
		{	
			this._initializeBullets()
		}

		// -- Toggle center hints
		if( this._rect.width <= this._rect.viewport )
		{
			this.$node.classList.add('maybe-center')
		}
		else 
		{	
			this.$node.classList.remove('maybe-center')
		}
		
		// -- Recalculate scroll 
		this._observeScroll()

	}

	/**
	 * Observe the scroll event
	 * 
	 * @access 	private
	 */
	_observeScroll()
	{
		var rect = this._getRect()

		// Filter arrow nav
		{
			var next = this.$node.querySelector('.slide-next')

			if( next )
			{	
				if( rect.left + rect.viewport < rect.width )
				{
					next.classList.add('active')
				}
				else
				{
					next.classList.remove('active')
				}
			}


			var prev = this.$node.querySelector('.slide-prev')

			if( prev )
			{
				if( rect.left )
				{
					prev.classList.add('active')
				}
				else 
				{	
					prev.classList.remove('active')
				}
			}
		}

		// Filter bullet nav
		if( this.$node.querySelector('.slide-nav.nav-bullet li') )
		{
			var active = this.$node.querySelector('.slide-nav.nav-bullet .active')

			if( active )
			{
				active.classList.remove('active')
			}
			
			var list  = Array.from( this.$node.querySelectorAll('.slide-nav.nav-bullet li') )

			var slide = this._getSlideNumber()
				slide = typeof list[ slide ] != 'undefined' ? slide : 0 

				list[ slide ].classList.add('active')
		}

		this._calculateFocus()
	}

	/**
	 * Purely to move the CTA to the end of the node. This because the bullets/navigation are appended dynamically and the CTA is appended through php/html. 
	 */
	_relocateCTA()
	{
		if( this.$node.querySelector('.cta') ) 
		{
			this.$node.appendChild( this.$node.querySelector('.cta') )
		}
	}

	/**
	 * Slide to the previous slide
	 * 
	 * @return 	Carousel
	 */
	slidePrev()
	{
		return this.slideTo( this._getSlideNumber() - 1 )
	}

	/**
	 * Slide to the next slide
	 * 
	 * @return 	Carousel
	 */
	slideNext()
	{
		return this.slideTo( this._getSlideNumber() + 1 )
	}

	/**
	 * Slide to a specific slide
	 * 
	 * @param 	int The $slide to slide to
	 * @return	Carousel
	 */
	slideTo ( slide )
	{	
		var rect = this._getRect()

		// Support loop trough
		slide = slide >= 0 ? slide : rect.slideCount - 1
		slide = slide < rect.slideCount ? slide : 0 

		var targetPosition  = slide * rect.slideWidth
		var $scrollFrame = this.$wrap

		// when no animation is availible
		if( typeof $scrollFrame.scrollTo == 'undefined' )
		{
			return $scrollFrame.scrollLeft = targetPosition
		}

		// Animate scroll
		let startPosition = $scrollFrame.scrollLeft;
		let distance = targetPosition - startPosition;
		let startTime = null;
		let duration = 600;

		const animation = (currentTime) => {
			startTime = startTime === null ? currentTime : startTime;
			
			let timeElapsed = currentTime - startTime;
			let run = ease(timeElapsed, startPosition, distance, duration);
			$scrollFrame.scrollTo(run, 0);
			if ( timeElapsed < duration ) {
				requestAnimationFrame( animation )
			}
		}

		const ease = (t, b, c, d) => {
			t /= d / 2;
			if (t < 1)  {
				return c / 2 * t * t * t + b;
			}
			t -= 2;
			return c / 2 * (t * t * t + 2) + b;
		};

		requestAnimationFrame( animation );

		return this
	}
}